export function parseTsx(tsx, canFail) {
    if (!tsx || tsx.length === 0) {
        return { type: 'array' };
    }
    const parser = new DOMParser();
    const document = parser.parseFromString(tsx, 'text/xml');
    if (document.getElementsByTagName('parsererror').length > 0) {
        if (!canFail) {
            console.error(document);
            const text = document.getElementsByTagName('parsererror')[0].innerText;
            return { type: 'error', properties: { title: 'Invalid XML.', text: text } };
        }
        return undefined;
    }
    return postProcesing(parseComponent(document.documentElement));
}
function parseComponent(node) {
    const result = {
        type: node.nodeName,
        children: [],
        properties: {},
    };
    for (let i = 0; i < node.attributes.length; i++) {
        const attr = node.attributes[i];
        result.properties[attr.nodeName] = updateAttr(attr.nodeValue);
    }
    if (node.childNodes.length === 1 && node.childNodes[0].nodeType === Node.TEXT_NODE) {
        result.properties['text'] = trimText(node.childNodes[0].nodeValue);
    }
    else {
        for (let i = 0; i < node.childNodes.length; i++) {
            const child = node.childNodes[i];
            if (child.nodeType === Node.ELEMENT_NODE) {
                result.children?.push(parseComponent(child));
            }
            else if (child.nodeType === Node.TEXT_NODE) {
                result.children?.push({
                    type: 'Text',
                    properties: {
                        text: trimText(child.nodeValue),
                    },
                });
            }
        }
    }
    return transformComponent(result);
}
function trimText(text) {
    if (!text) {
        return '';
    }
    let result = text.trim();
    if (result.length === 0) {
        return '';
    }
    if (text[0] === ' ') {
        result = ' ' + result;
    }
    if (text[text.length - 1] === ' ') {
        result = result + ' ';
    }
    return result;
}
function postProcesing(component) {
    const parts = [];
    let result = getParts(component, parts);
    if (result) {
        result = replaceParts(result, parts);
    }
    return result ?? { type: 'array' };
}
function transformComponent(component) {
    const type = component.type.toLowerCase();
    if (type === 'cs') {
        component.type = 'If';
        component.properties.culture = 'cs';
    }
    if (type === 'en') {
        component.type = 'If';
        component.properties.culture = 'en';
    }
    return component;
}
function updateAttr(attribute) {
    if (attribute.toLowerCase() === 'true') {
        return true;
    }
    if (attribute.toLowerCase() === 'false') {
        return false;
    }
    return attribute;
}
function getParts(component, parts) {
    const type = component.type.toLowerCase();
    if (type === 'component' || type === 'part') {
        component.type = 'array';
        parts.push(component);
        return null;
    }
    else {
        component.children = component.children
            ?.map(c => getParts(c, parts))
            .filter(i => i);
        return component;
    }
}
function replaceParts(component, parts) {
    const type = component.type.toLowerCase();
    if (type === 'include' || type === 'use') {
        const partName = component.properties.component ?? component.properties.part ?? '';
        const part = parts.find(c => c.properties.name === partName);
        return part ?? null;
    }
    else {
        component.children = component.children
            ?.map(c => replaceParts(c, parts))
            .filter(i => i);
        return component;
    }
}
